module.exports = __webpack_public_path__ + "img/mind_map.949c3bdb.svg";